/* Groundnut discover page: scroll scene, turning bottle, floating pieces, cards. */
(function () {
  'use strict';
  var KEY = '__ndsc_ngn';
  if (window[KEY]) return;
  window[KEY] = true;

  var SIZES = {"pod": [70, 105], "kernel": [30, 46], "leaf": [46, 72], "drop": [26, 42], "pin": [30, 40], "clock": [30, 40]};
  var TAU = Math.PI * 2;
  var HALF = Math.PI / 2;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smooth(t) { return t * t * (3 - 2 * t); }
  function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function random(seed) {
    var a = seed;
    return function () {
      a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function load(src) {
    return new Promise(function (resolve, reject) {
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { resolve(im); };
      im.onerror = reject;
      im.src = src;
    });
  }

  /* ---------- turning bottle (canvas) ---------- */
  // Redraws the label band column by column, as if the label were wrapped round the bottle.
  function makeTurner(el) {
    var canvas = el.querySelector('canvas');
    var mode = el.getAttribute('data-mode');
    var frontSrc = el.getAttribute('data-front');
    if (!canvas || mode === 'off' || !frontSrc || !canvas.getContext) return null;
    var ctx = canvas.getContext('2d');
    var g = {
      cx: parseFloat(el.getAttribute('data-cx')) / 100 || .5,
      r: parseFloat(el.getAttribute('data-r')) / 100 || .1,
      top: parseFloat(el.getAttribute('data-top')) / 100 || .35,
      bottom: parseFloat(el.getAttribute('data-bottom')) / 100 || .9
    };
    var backSrc = el.getAttribute('data-back');
    var front = null, back = null, angle = 0, drawn = '';

    function draw() {
      if (!front) return;
      var W = canvas.width, H = canvas.height;
      if (!W || !H) return;
      var a = mode === 'turn' ? ((angle % TAU) + TAU) % TAU : Math.sin(angle) * .55;
      var key = a.toFixed(4) + '|' + W + 'x' + H;
      if (key === drawn) return;
      drawn = key;
      var iw = front.naturalWidth, ih = front.naturalHeight;
      var sc = Math.min(W / iw, H / ih), dw = iw * sc, dh = ih * sc, dx = (W - dw) / 2, dy = (H - dh) / 2;
      ctx.clearRect(0, 0, W, H);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(front, dx, dy, dw, dh);
      var rest = mode === 'turn' ? Math.min(a, TAU - a) : Math.abs(a);
      if (rest < 1e-3) return;
      var x0 = Math.floor(dx + (g.cx - g.r) * dw), x1 = Math.ceil(dx + (g.cx + g.r) * dw);
      var y0 = dy + g.top * dh, yh = (g.bottom - g.top) * dh;
      var flat = Math.pow(Math.sin(a), 2) * .6; // eases the wrap mid-turn so flat labels don't over-stretch
      ctx.clearRect(x0, y0, x1 - x0, yh);
      for (var x = x0; x < x1; x++) {
        var u = clamp(((x + .5 - dx) / dw - g.cx) / g.r, -.9999, .9999);
        var t = Math.asin(u) + a;
        t = Math.atan2(Math.sin(t), Math.cos(t));
        var rear = Math.abs(t) > HALF;
        var src = front;
        if (rear) {
          if (mode === 'turn' && back) { src = back; t = Math.atan2(Math.sin(t - Math.PI), Math.cos(t - Math.PI)); }
          else { t = t > 0 ? HALF * .995 : -HALF * .995; }
        }
        var pos = Math.sin(t) * (1 - flat) + (t / HALF) * flat;
        var slope = (Math.cos(t) * (1 - flat) + flat / HALF) / Math.sqrt(1 - u * u);
        var sw = src.naturalWidth, shh = src.naturalHeight;
        var colW = clamp(slope * sw / dw, .5, 24);
        var sx = clamp((g.cx + g.r * pos) * sw - colW / 2, (g.cx - g.r) * sw + 1, (g.cx + g.r) * sw - colW - 1);
        ctx.drawImage(src, sx, g.top * shh, colW, (g.bottom - g.top) * shh, x, y0, 1, yh);
      }
    }
    function size() {
      var r = Math.max(1, Math.min(window.devicePixelRatio || 1, 2));
      var w = Math.max(1, Math.round(canvas.clientWidth * r)), h = Math.max(1, Math.round(canvas.clientHeight * r));
      if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; drawn = ''; }
      draw();
    }
    var jobs = [load(frontSrc)];
    if (mode === 'turn' && backSrc) jobs.push(load(backSrc));
    Promise.all(jobs).then(function (imgs) {
      front = imgs[0]; back = imgs[1] || null;
      size();
      el.setAttribute('data-ready', '');
      if (window.ResizeObserver) new ResizeObserver(size).observe(canvas);
      else window.addEventListener('resize', size);
    }).catch(function () { el.setAttribute('data-error', ''); });
    return { turn: function (v) { angle = v; draw(); } };
  }

  /* ---------- floating pieces ---------- */
  function buildPieces(root, orbit, data) {
    var rnd = random(hash(root.id || 'nune'));
    var list = [];
    Object.keys(data).forEach(function (kind) {
      var n = parseInt(data[kind], 10) || 0;
      var sz = SIZES[kind] || [30, 50];
      for (var i = 0; i < n; i++) {
        var x = 0, y = 0;
        for (var k = 0; k < 40; k++) {
          x = (rnd() * 2 - 1) * 47; y = (rnd() * 2 - 1) * 45;
          var clear = Math.abs(x) > 12 || Math.abs(y) > 38;
          var apart = list.every(function (q) { return Math.hypot(q.x - x, (q.y - y) * .8) > 7; });
          if (clear && apart) break;
        }
        var depth = .4 + rnd() * .85;
        list.push({ kind: kind, x: x, y: y, depth: depth, size: Math.round((sz[0] + rnd() * (sz[1] - sz[0])) * (.62 + depth * .42)),
          rot: Math.round(rnd() * 360), dur: 3.2 + rnd() * 3.4, delay: -rnd() * 6, phone: i % 2 === 0 });
      }
    });
    var frag = document.createDocumentFragment();
    list.forEach(function (q) {
      var b = document.createElement('span');
      b.className = 'ngn-dsc__bit' + (q.phone ? '' : ' is-desk') + (q.depth < .62 ? ' is-far' : q.depth > 1.12 ? ' is-near' : '');
      b.setAttribute('data-kind', q.kind);
      b.style.cssText = '--x:' + q.x.toFixed(2) + 'vw;--y:' + q.y.toFixed(2) + 'vh;--d:' + q.depth.toFixed(3) + ';--sz:' + q.size + 'px;--r:' + q.rot +
        'deg;--dur:' + q.dur.toFixed(2) + 's;--delay:' + q.delay.toFixed(2) + 's';
      b.innerHTML = '<span class="ngn-dsc__float"><svg viewBox="0 0 100 100" focusable="false"><use href="#ngn-spr-' + q.kind + '"></use></svg></span>';
      frag.appendChild(b);
    });
    orbit.appendChild(frag);
  }

  /* ---------- section ---------- */
  function init(root) {
    if (root.__dsc) return;
    root.__dsc = true;
    var scene = root.querySelector('[data-scene]');
    var turnEl = root.querySelector('[data-turn]');
    var field = root.querySelector('[data-field]');
    var orbit = root.querySelector('[data-orbit]');
    var turner = turnEl ? makeTurner(turnEl) : null;
    var live = !mq.matches;

    // ingredient rows: open one at a time, and bring their pieces forward on hover
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-ing]'));
    function focusKinds(kinds) {
      if (!field) return;
      var on = kinds && kinds !== 'none';
      field.classList.toggle('has-focus', !!on);
      Array.prototype.forEach.call(field.querySelectorAll('[data-kind]'), function (b) {
        b.classList.toggle('is-focus', !!on && (' ' + kinds + ' ').indexOf(' ' + b.getAttribute('data-kind') + ' ') > -1);
      });
    }
    rows.forEach(function (btn) {
      var li = btn.parentNode;
      btn.addEventListener('click', function () {
        if (!btn.hasAttribute('aria-expanded')) { focusKinds(btn.getAttribute('data-focus')); return; }
        var open = btn.getAttribute('aria-expanded') !== 'true';
        rows.forEach(function (o) {
          if (o.hasAttribute('aria-expanded')) { o.setAttribute('aria-expanded', 'false'); o.parentNode.classList.remove('is-open'); }
        });
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        li.classList.toggle('is-open', open);
        focusKinds(open ? btn.getAttribute('data-focus') : null);
      });
      btn.addEventListener('mouseenter', function () { focusKinds(btn.getAttribute('data-focus')); });
      btn.addEventListener('mouseleave', function () { focusKinds(null); });
      btn.addEventListener('focus', function () { focusKinds(btn.getAttribute('data-focus')); });
      btn.addEventListener('blur', function () { focusKinds(null); });
    });

    if (!live || !scene) {
      root.classList.add('is-static');
      if (turner) turner.turn(0);
      return;
    }
    root.classList.add('is-live');

    if (field && orbit) {
      var json = root.querySelector('[data-scatter]');
      try { buildPieces(root, orbit, JSON.parse(json ? json.textContent : '{}')); } catch (e) { /* bad settings: no pieces */ }
    }

    // scroll-driven scene, with a little easing so it glides
    var sceneTop = 0, vh = 0, sy = window.pageYOffset, raf = 0, last = 0, wantFocus = false;
    function measure() {
      vh = window.innerHeight;
      var r = scene.getBoundingClientRect();
      sceneTop = r.top + window.pageYOffset;
    }
    function frame(now) {
      var dt = last ? Math.min(now - last, 40) : 16;
      last = now;
      var y = window.pageYOffset;
      sy += (y - sy) * (1 - Math.exp(-dt / 65));
      if (Math.abs(y - sy) < .5) sy = y;
      var f = Math.max(0, sy - sceneTop) / vh;
      var p = smooth(clamp(f / .42, 0, 1));
      var m = clamp((f - .42) / 1.12, 0, 1);
      root.style.setProperty('--arrival', p.toFixed(4));
      root.style.setProperty('--spin', m.toFixed(4));
      if (turner) turner.turn(m * TAU);
      var on = p > .6;
      if ((scene.getAttribute('data-panels') === 'on') !== on) scene.setAttribute('data-panels', on ? 'on' : 'off');
      scene.setAttribute('data-intro', p < .35 ? 'on' : 'off');
      if (on && wantFocus) {
        wantFocus = false;
        var first = root.querySelector('[data-panel] a, [data-panel] button');
        if (first) first.focus({ preventScroll: true });
      }
      if (sy !== y) raf = requestAnimationFrame(frame);
      else { raf = 0; last = 0; }
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }
    measure();
    kick();
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', function () { measure(); kick(); });
    window.addEventListener('load', function () { measure(); kick(); });

    function panelsY() { return sceneTop + vh * .75; }
    var explore = root.querySelector('[data-explore]');
    if (explore) explore.addEventListener('click', function () {
      measure();
      wantFocus = true;
      window.scrollTo({ top: panelsY(), behavior: 'smooth' });
    });
    // keyboard users tabbing into a card: jump the scene to where the cards are showing
    root.addEventListener('focusin', function (e) {
      var panel = e.target.closest && e.target.closest('[data-panel]');
      if (!panel || scene.getAttribute('data-panels') === 'on') return;
      measure();
      window.scrollTo({ top: panelsY(), behavior: 'auto' });
      sy = window.pageYOffset;
      kick();
    });

    // pieces and bottle follow the mouse
    var tx = 0, ty = 0, cx = 0, cy = 0, praf = 0, visible = false;
    function ptick() {
      cx += (tx - cx) * .08; cy += (ty - cy) * .08;
      root.style.setProperty('--px', cx.toFixed(3));
      root.style.setProperty('--py', cy.toFixed(3));
      praf = Math.abs(tx - cx) + Math.abs(ty - cy) > .002 ? requestAnimationFrame(ptick) : 0;
    }
    window.addEventListener('pointermove', function (e) {
      if (!visible || e.pointerType === 'touch') return;
      tx = e.clientX / window.innerWidth * 2 - 1;
      ty = e.clientY / window.innerHeight * 2 - 1;
      if (!praf) praf = requestAnimationFrame(ptick);
    }, { passive: true });
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(scene);
    } else { visible = true; }
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-ngn-dsc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
